import { render } from "./DMonthWeek.vue?vue&type=template&id=f2128d66&scoped=true"
import script from "./DMonthWeek.vue?vue&type=script&lang=js"
export * from "./DMonthWeek.vue?vue&type=script&lang=js"

import "./DMonthWeek.vue?vue&type=style&index=0&id=f2128d66&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2128d66"]])

export default __exports__